module.exports = __webpack_public_path__ + "img/login_top.06ad4829.png";